export default __webpack_public_path__ + "static/media/farwest_vs_foreal_texture.fe216960.jpg";